module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kbx-trigger-content"
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": _vm.themeCdnUri + '/popup.css'
    }
  }), _vm._v(" "), (_vm.boxConfig.trigger_button.kind === 'basic') ? _c('input', {
    staticClass: "kbx-trigger-btn kbx-trigger-button",
    style: (_vm.boxConfig.trigger_button.style),
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.boxConfig.trigger_button.text
    },
    on: {
      "change": function($event) {
        return _vm.boxUpdateConfig({
          item: 'trigger_button',
          key: 'text',
          value: $event.target.value
        })
      }
    }
  }) : _vm._e()])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-ed3c0d00!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/triggerbutton/Basic.vue
 ** module id = 920
 ** module chunks = 1
 **/